import { call } from 'redux-saga/effects';
import { MapResource } from '../../core/resources/map.resource';

export function* getAffinyPlaceId(
  providerPlaceId: string,
  lat: number,
  lng: number
) {
  return yield call(MapResource.getAffinyPlaceId, providerPlaceId, lat, lng);
}
